<template>
    <div>
        <b-container fluid>
            <b-row class="row-color" >
                <b-col md="4" class="pl-0 p_0">
                    <img src="../assets/img/imgcreatividad1.png" alt="Creatividad 1">
                </b-col>
                <b-col md="4" class="align-self-center text-col">
                    <h1>Creatividad y Diseño, Aprendizaje y Conexiones</h1>
                </b-col>
                <b-col md="4" class="pr-0 p_0">
                    <img src="../assets/img/imgcreatividad2.png" alt="Creatividad 2">
                </b-col>
            </b-row>

            <b-row class="row-color" >
                <b-col lg="4" class="pr-0 pl-0">
                    <img src="../assets/img/imginspo1.png" alt="Inspo 1">
                </b-col>
                <b-col lg="4" class="align-self-center text-col">
                    <h3>Encuentra la inspiración que necesitas…</h3>
                    <p>Nos ha inspirado crear un ambiente donde quienes nos visiten se sientan parte de nuestra	 comunidad. Queremos que este sea un lugar donde las personas no solo vengan a comprar, sino también a encontrar inspiración en los talleres y cursos que ofrecemos, descubrir productos seleccionados con cuidado, y sentirse como en casa.</p>
                </b-col>
                <b-col lg="4" class="pr-0 pl-0">
                    <img src="../assets/img/imginspo2.png" alt="Inspo 2">
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.row-color{
    background: #5D867C;
    margin-bottom: 130px;
    color: #fff;
}
h1{
    font-size: 35px;
}
h3{
    font-size: 30px;
    max-width: 90%;
    margin: 20px auto;
}
p{
    font-size: 20px;
    max-width: 90%;
    margin: auto;
}
img{ 
    width: 100%;
}
@media (max-width: 1180px){
    h3{
        font-size: 29px;
    }
    p{
        font-size: 17px;
    }
}
@media (max-width: 992px){
    .text-col{
        padding: 50px 20px;
    }
    p{
        font-size: 17px;
    }
    .p_0{
        padding: 0 !important;
    }
}
</style>